import { useMutation, useQueryClient } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type ExchangeBankAccountTokenBody =
  operations['exchangeSupplierIntegrationPublicToken']['requestBody']['content']['application/json'];

export type ExchangeBankAccountTokenResponse =
  operations['exchangeSupplierIntegrationPublicToken']['responses'][201]['content']['application/json'];

const useExchangeBankAccountToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['exchangeBankAccountToken'],
    mutationFn: (body: ExchangeBankAccountTokenBody) => {
      return apiClient
        .post('api/supplier-experience/bank-accounts/exchange', { json: body })
        .json<ExchangeBankAccountTokenResponse>();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyStatus'] });
    },
  });
};

export default useExchangeBankAccountToken;
